import React, { Component } from 'react'
import ieIcon from '../../images/browsers/icons8-internet-explorer-50.png'
import chromeIcon from '../../images/browsers/icons8-chrome-50.png'
import safariIcon from '../../images/browsers/icons8-safari-50.png'
import firefoxIcon from '../../images/browsers/icons8-firefox-50.png'
import operaIcon from '../../images/browsers/icons8-opera-50.png'

export default class OldBrowser extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      browser: props.browser,
    }
  }

  render() {
    return (
      <section id='old-browser'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 text-center'>
              <h1>Az Ön által használt böngésző elavult, kérjük frissítse.</h1>
            </div>
          </div>
          {/* <div className='row'>
            <div className='col-12 text-center'>
              <br />
              <br />
              Böngésző: {this.state.browser.name.toUpperCase()}&nbsp;&nbsp;
              Verzió: {this.state.browser.version}
            </div>
    </div> */}
          <div className='row margin-top-100'>
            <div className='col-2 offset-lg-1 text-center'>
              <img src={chromeIcon} alt='GOOGLE CHROME' title='GOOGLE CHROME' />
              <h3>GOOGLE CHROME</h3>
              <a className='green-btn' href='https://www.google.com/chrome/browser/desktop/' target='_blank'>Letöltés</a>
              <span className='latest-version'>legfrisebb verzió: 68</span>
            </div>
            <div className='col-2 text-center'>
              <img src={firefoxIcon} alt='MOZILLA FIREFOX' title='MOZILLA FIREFOX' />
              <h3>MOZILLA FIREFOX</h3>
              <a className='green-btn' href='http://www.mozilla.org/firefox/new/' target='_blank'>Letöltés</a>
              <span className='latest-version'>legfrisebb verzió: 61</span>
            </div>
            <div className='col-2 text-center'>
              <img src={ieIcon} alt='MICROSOFT EDGE' title='MICROSOFT EDGE' />
              <h3>MICROSOFT EDGE</h3>
              <a className='green-btn' href="https://www.microsoft.com/software-download/windows10" target='_blank'>Letöltés</a>
              <span className='latest-version'>legfrisebb verzió: 18</span>
            </div>
            <div className='col-2 text-center'>
              <img src={safariIcon} alt='APPLE SAFARI' title='APPLE SAFARI' />
              <h3>APPLE SAFARI</h3>
              <a className='green-btn' href='https://support.apple.com/downloads/safari' target='_blank'>Letöltés</a>
              <span className='latest-version'>legfrisebb verzió: 11</span>
            </div>
            <div className='col-2 text-center'>
              <img src={operaIcon} alt='OPERA' title='OPERA' />
              <h3>OPERA</h3>
              <a className='green-btn' href='https://www.opera.com/' target='_blank'>Letöltés</a>
              <span className='latest-version'> legfrisebbverzió: 55</span>
            </div>
          </div>
        </div>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/oldbrowser.js